import axios from 'axios'

// TODO: 接口地址
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL || '/',
  timeout: 10000,
})

export default request
